import { AppSettings } from 'app/sharedcomponents/_common/constants/app.constants';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Observable } from 'rxjs/Observable';
import { locationType, PickupType, SendMoneyDetail, SendMoneySteps } from '../../models/sendmoney/sendmoney';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { InfoPopupComponent } from '../../sharedcomponents/_directive/info-popup/info-popup.component';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { Ng2DeviceService } from "ng2-device-detector";
@Component({
  selector: 'app-agent-details',
  templateUrl: './agent-details.component.html',
  styleUrls: ['./agent-details.component.css'],
  providers: [AlertService, Modal, CountryService]
})
export class AgentDetailsComponent implements OnInit {
  PageFlow: any = {};
  sendMoneyDetail: SendMoneyDetail;
  summaryDetailData: any = {};
  docReqList = [];
  public firstname: string;
  public lastname: string;
  public FilterBy: any;
  public locationEnum: any;
  public pickupType: number;
  public enumPickupType: any;
  constructor(
    private router: Router,
    private modal: Modal,
    private alertService: AlertService,
    private countryserv: CountryService,
    private sendMoneyService: SendMoneyService,
    private vcRef: ViewContainerRef,
    public utilServ: utilityService,
    private deviceService: Ng2DeviceService,
    public translate: TranslateService
  ) {
    this.locationEnum = locationType;
    // this.sendMoneyService.getPageFlow().subscribe(data => {
    //   this.PageFlow = data;
    // });
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    if (this.sendMoneyDetail.pickupTypeDetails.countryName == undefined || this.sendMoneyDetail.pickupTypeDetails.countryName == '') {
      if (this.PageFlow.Value == 'repeatorder') {
        if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
          this.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
        } else {
          this.router.navigate(['/repeatorderlist']);
        }
      } else {
        this.router.navigate(['/dashboard']);
      }
      return;
    }
    this.enumPickupType = PickupType;
    this.pickupType = this.sendMoneyDetail.pickupTypeDetails.pickupType;
  }
  canDeactivate(): Observable<boolean> | boolean {
    if (this.sendMoneyDetail.isData == true && this.PageFlow.Value == 'sendmoney') {
      let _self=this;
      return Observable.create(observer => {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        let loading = false;
        modalData.Title = this.translate.instant('Common_lblConfirm');
        modalData.Message = this.translate.instant('SendMoney_navigateConfirmDesc');
        this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(data => {
            if (modalData.next == 'yes') {
              let DeviceDetail = _self.deviceService.getDeviceInfo();
              (<any>window).firebase
                .analytics()
                .logEvent("UnfinishedTransaction", {
                  Screen: "PickupCenter",
                  Platform: AppSettings.Platform,
                  Browser: DeviceDetail.browser,
                  OSVersion: DeviceDetail.os_version,
                  AppVersion: AppSettings.Appversion
                });
              observer.next(true);
              observer.complete();
            } else {
              observer.next(false);
              observer.complete();
            }
          });
        });
      });
    }
    return true;
  }

  ngOnInit() {}

  continueClick() {
    if (this.pickupType == PickupType.officePickup || this.pickupType == PickupType.homeDelivery || this.pickupType == PickupType.atmDeposit) {
      if (this.PageFlow.Value == 'repeatorder') {
        if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
          this.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
        } else {
          this.router.navigate(['/repeatorderlist']);
        }
        return;
      } else {
        this.sendMoneyService.setModalPopup(SendMoneySteps.Beneficiary);
        this.router.navigate(['/sendmoney']);
        return;
      }
    } else if (this.pickupType == PickupType.bankDeposit) {
      this.router.navigate(['/addaccountdetail']);
      return;
    }
  }

  branchClick() {
    this.router.navigate(['/branchedetails']);
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/agent-details/agent-details.component.ts